/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MessageDetailResponse } from '../../models/message-detail-response';

export interface GetMessage$Params {
  id: number;
}

export function getMessage(http: HttpClient, rootUrl: string, params: GetMessage$Params, context?: HttpContext): Observable<StrictHttpResponse<MessageDetailResponse>> {
  const rb = new RequestBuilder(rootUrl, getMessage.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MessageDetailResponse>;
    })
  );
}

getMessage.PATH = '/api/chat/message/{id}';
